export class SearchResultModel<M, FILTERS_TYPE_OBJECT> {
  content: M[];
  objectResearch: FILTERS_TYPE_OBJECT;
  total: number;
}
